/* eslint-disable import/prefer-default-export */
import {
  petitionsRequest,
  petitionsSuccess,
  petitionsFailure,
} from './actionCreators';

import { getPetitions } from './api.service';

export const fetchPetitions = (query) => async (dispatch) => {
  try {
    dispatch(petitionsRequest());
    const { data } = await getPetitions({ ...query });
    dispatch(petitionsSuccess(data.data, { ...query, ...data.meta }));
  } catch ({ message }) {
    dispatch(petitionsFailure(message));
  }
};
